import React from 'react';
import {
  BooleanField,
  Datagrid,
  DateField,
  List,
  NumberField,
  Resource,
  TextField,
} from 'react-admin';
import HistoryIcon from '@material-ui/icons/History';

export const AuditEventList = props => (
  <List
    {...props}
    bulkActionButtons={false}
    perPage={25}
    sort={{ field: 'createdAt', order: 'DESC' }}
    title="System audit"
  >
    <Datagrid>
      <DateField source="createdAt" label="When" showTime />
      <TextField source="actorName" label="User" />
      <TextField source="targetAccountName" label="Account" />
      <TextField source="action" label="What happened" />
      <TextField source="path" label="Endpoint" />
      <TextField source="entityId" label="Record" emptyText="—" />
      <NumberField source="statusCode" label="HTTP status" />
      <BooleanField source="succeeded" label="Succeeded" />
      <NumberField source="durationMs" label="Duration (ms)" />
    </Datagrid>
  </List>
);

const auditEventResource = () => (
  <Resource
    name="auditEvents"
    options={{ label: 'System audit', menuGroup: 'Commercial' }}
    icon={HistoryIcon}
    list={AuditEventList}
  />
);

export default auditEventResource;
